function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

module.exports = _taggedTemplateLiteralLoose;


//////////////////
// WEBPACK FOOTER
// ./node_modules/yup/node_modules/@babel/runtime/helpers/taggedTemplateLiteralLoose.js
// module id = 587
// module chunks = 0